const applyConditionalClassNames = (obj: Record<string, any>) =>
  Object.keys(obj)
    .filter((key) => !!obj[key])
    .join(' ');

export default applyConditionalClassNames;
